import { render, staticRenderFns } from "./importTemplateModal.vue?vue&type=template&id=72c26d55&scoped=true&"
import script from "./importTemplateModal.vue?vue&type=script&lang=js&"
export * from "./importTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./importTemplateModal.vue?vue&type=style&index=0&id=72c26d55&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c26d55",
  null
  
)

export default component.exports